'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

interface BackButtonContextType {
  showBackButton: boolean;
  setShowBackButton: (show: boolean) => void;
  backButtonFallback: string;
  setBackButtonFallback: (url: string) => void;
}

const BackButtonContext = createContext<BackButtonContextType | undefined>(undefined);

export function BackButtonProvider({ children }: { children: ReactNode }) {
  const [showBackButton, setShowBackButton] = useState(false);
  const [backButtonFallback, setBackButtonFallback] = useState('/');

  return (
    <BackButtonContext.Provider
      value={{
        showBackButton,
        setShowBackButton,
        backButtonFallback,
        setBackButtonFallback,
      }}
    >
      {children}
    </BackButtonContext.Provider>
  );
}

export function useBackButton() {
  const context = useContext(BackButtonContext);
  if (context === undefined) {
    throw new Error('useBackButton must be used within a BackButtonProvider');
  }
  return context;
}
